export default __webpack_public_path__ + "static/media/CasualCollege1.f04ac0d7.jpg";